module.exports = __webpack_public_path__ + "img/aslam-logo-v2.e2edf131.png";